import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"c-app-store-product\"></div>",{ moduleName: "mewe/pods/components/routable/app-store-product/template.hbs" })